export const CheckIcon = ({ className, color = '#007CFF' }: { className?: string, color?: string }) => (
  <svg
    width='16'
    height='15'
    viewBox='0 0 16 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M5.97656 14.7759C5.46191 14.7759 5.03304 14.5711 4.68994 14.1616L0.406738 8.97363C0.257324 8.80208 0.152181 8.63607 0.0913086 8.47559C0.0304362 8.3151 0 8.14909 0 7.97754C0 7.58464 0.130046 7.2609 0.390137 7.00635C0.655762 6.74626 0.987793 6.61621 1.38623 6.61621C1.82894 6.61621 2.19694 6.79606 2.49023 7.15576L5.94336 11.4307L12.7251 0.714355C12.8966 0.454264 13.0737 0.271647 13.2563 0.166504C13.4445 0.0558268 13.6742 0.000488281 13.9453 0.000488281C14.3438 0.000488281 14.673 0.127767 14.9331 0.382324C15.1932 0.636882 15.3232 0.957845 15.3232 1.34521C15.3232 1.4891 15.2983 1.63851 15.2485 1.79346C15.1987 1.9484 15.1213 2.10889 15.0161 2.2749L7.28809 14.1035C6.98372 14.5518 6.54655 14.7759 5.97656 14.7759Z'
      fill={color}
    />
  </svg>
);
